export default __webpack_public_path__ + "static/media/portfolioDefaultImage.faa5705f.png";